import { render, staticRenderFns } from "./ProductHasBoughtAlready.vue?vue&type=template&id=56e5cb60&"
import script from "./ProductHasBoughtAlready.vue?vue&type=script&lang=js&"
export * from "./ProductHasBoughtAlready.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports